<svelte:options tag="fds-ai-image-editor"></svelte:options>
<script>
    import { onMount } from 'svelte'
    import {get_current_component} from "svelte/internal"
    let host = get_current_component()
    import fdsHelper from "@fds-components/fds-helper"
    let path = fdsHelper.get_href()
    import FirstConfig from "./postmessageadapter/FirstConfig.svelte";
    import { version as componentversion,name } from '../package.json';
    import PostMessageAdapter  from "./postmessageadapter/postMessageAdapter"

    /**
     * example parameter
     * @type {string}
     */

    /**
     * Get information about component
     * @param  {("api" | "examples" | "css")} type the info type
     */
    export async function getInfo(type) {
        if (type==="version"){
            return new Promise(resolve => {
                resolve(componentversion);
            });
        }
        let res = await fdsHelper.getInfo(type,name);
        return res;    
    }

    /**
     * version of component
     * @type {string}
     */
    export const version = componentversion;
    let postMessageAdapter;

    onMount(()=> {

    })
    $: {}

</script>